<template>
    <v-sheet class="defaultCard" color="bgtopology">
        <span class="titlePages"> Estado DB </span>
        <v-row v-if="databaseInfo" class="ma-0 mt-3">

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.cambium_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.cambium_data === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Cambium Data</h2>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.eventos === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.eventos === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Eventos</h2>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  pt-7 text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.latencia === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.latencia === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Latencia</h2>
                </v-card>
            </v-col>
            
            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo?.LTE_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.LTE_data === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">LTE Data</h2>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.predicciones === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.predicciones === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Predicciones</h2>
                </v-card>
            </v-col> 

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.rajant_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.rajant_data === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Rajant Data</h2>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.sensores === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.sensores === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Sensores</h2>
                </v-card>
            </v-col> 

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.servidor_data === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.servidor_data === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Servidor Data</h2>
                </v-card>
            </v-col> 

            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-card color="bgDashCard" class="dbCard pt-7  text-center" height="170">
                    <v-icon 
                    size="70"
                    :icon="databaseInfo.ubicacion_gps === 1 ? 'mdi-database-outline' : 'mdi-database-off-outline'"
                    :color="databaseInfo.ubicacion_gps === 1 ? 'green' : 'red'"/>
                    <h2 class="subtitleDashboard">Ubicación GPS</h2>
                </v-card>
            </v-col> 
        </v-row>
    </v-sheet>
</template>

<script setup lang="ts">
import { onMounted, ref, Ref } from 'vue'
import axios        from 'axios'

// COMPONENTS
import CONSTAPIS    from '@/constants/apis';
import { TIMEOUTTIME } from '@/constants/apis';

// INTERFACES
import { DBSTATUS } from '@/interfaces/SmartLink/Admin'
import { showConsoleError } from '@/functions/errors'
import { TOKEN } from '@/constants/labels';

const databaseInfo:Ref<DBSTATUS> = ref({})
        
onMounted(async() => {
    /**
     * Captura los valores de la API: 'getDataBaseStatus'
     */
    await axios.get(CONSTAPIS.APIS.value.general.getDBStatus, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((res)=>{
        databaseInfo.value = res.data[0];
    })
    .catch(function (error) {
        showConsoleError(error);
    });
})

</script>

<style scoped>
    .dbCard {
        border-radius: 20px;
    }
</style>